import { render, staticRenderFns } from "./ControlNumber.vue?vue&type=template&id=7671aec3"
import script from "./ControlNumber.vue?vue&type=script&lang=js"
export * from "./ControlNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports